import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LmoFracModalService {
  private homeCloser$$: Subject<null> = new Subject();
  private stageCloser$$: Subject<null> = new Subject();
  private listCloser$$: Subject<null> = new Subject();

  public get homeCloser$(): Observable<null> {
    return this.homeCloser$$.asObservable();
  }

  public get stageCloser$(): Observable<null> {
    return this.stageCloser$$.asObservable();
  }

  public get listCloser$(): Observable<null> {
    return this.listCloser$$.asObservable();
  }

  constructor() {}

  public closeHomeModal(): void {
    this.homeCloser$$.next(null);
  }

  public closeStageModal(): void {
    this.stageCloser$$.next(null);
  }

  public closeListModal(): void {
    this.listCloser$$.next(null);
  }
}
